import React from "react"
//import I18n from "i18n-js/index.js.erb"


class FormDropdown extends React.Component {
  constructor(props) {
    super(props);
    this._onClick = this._onClick.bind(this);
  }

  render() {

    return (
      <div className="editor-dropdown links" onClick={this._onClick}>
        <a href="#" className="dropdown-link" onClick={this.props.onInsertForm.bind(null, PageBuilderConstants.GUEST_INFORMATION_FORM)}>{I18n.t('guest_information_form')}</a>
        <a href="#" className="dropdown-link" onClick={this.props.onInsertForm.bind(null, PageBuilderConstants.SELECT_ACCOMODATIONS_FORM)}>{I18n.t('select_accommodations_form')}</a>
        <a href="#" className="dropdown-link" onClick={this.props.onInsertForm.bind(null, PageBuilderConstants.SELECT_DATES_FORM)}>{I18n.t('select_dates_form')}</a>
      </div>
    );
  }

  _onClick(event) {
    event.stopPropagation();
    event.preventDefault();
  }

};

export default FormDropdown
